export const AVAILABLE = "Available";
export const ASSIGNED = "Assigned";
export const RELEASED = "Released";
export const RELEASE_PENDING = "Released - Pending";